export function compose(...f) {
    return (value) => f.reduce((result, f) => f(result), value);
}
export class Pipeable {
    pipe(...f) {
        return compose(...f)(this);
    }
}
//# sourceMappingURL=pipe.js.map